<template>
    <svg id="Camada_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.55 138.64">
        <path
            fill="#fbbf24"
            d="M4.78,111.28c-2.64,0-4.78-2.14-4.78-4.78V4.78C0,2.14,2.14,0,4.78,0s4.78,2.14,4.78,4.78V106.5c0,2.64-2.14,4.78-4.78,4.78Z" />
        <path
            fill="#fbbf24"
            d="M4.78,138.64c-.32,0-.62-.03-.94-.1-.31-.06-.6-.15-.89-.27-.29-.12-.57-.27-.83-.44-.26-.17-.51-.37-.73-.59-.89-.89-1.39-2.12-1.39-3.38,0-.31,.03-.62,.1-.94,.06-.3,.15-.6,.27-.89,.12-.29,.27-.56,.44-.82,.17-.27,.37-.51,.59-.73,.22-.22,.47-.42,.73-.6,.26-.17,.54-.32,.83-.44,.29-.11,.58-.21,.89-.27,.62-.12,1.25-.12,1.87,0,.31,.06,.6,.15,.89,.27,.29,.12,.56,.27,.82,.44,.27,.18,.51,.38,.73,.6,.23,.22,.43,.46,.6,.73,.17,.26,.32,.53,.44,.82,.11,.29,.21,.59,.27,.89,.07,.32,.1,.63,.1,.94s-.03,.63-.1,.94c-.06,.31-.15,.6-.27,.89-.12,.3-.27,.57-.44,.83-.17,.26-.37,.51-.6,.73-.22,.22-.46,.42-.73,.59-.26,.17-.53,.32-.82,.44-.29,.11-.58,.21-.89,.27-.32,.07-.62,.1-.94,.1Z" />
    </svg>
</template>

<script setup>

</script>

<style>

</style>
